// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"f0195d1c","176":"6dbd6dc6","262":"df36b347","607":"7ab718f8","623":"3870faf0","642":"8371b26f","725":"78cac1fa","768":"4aaf400f","885":"15e0847f","888":"f0cbe390"}[chunkId] + ".chunk.js";
};